import { loadState } from '../Common/localStorage'

const TOKEN = 'access_token';

let socialLoginTab = null;
let showSpinner = null;
let reloadPage = false;
let closeAuthModal, setAuthToken;

export const openRedirectUrl = (redirectUrl, {
     showSpinnerManually, isItEditorPage, isItAnniversaryLandingPage, closeModal, setToken
}) => {
    showSpinner = showSpinnerManually;
    closeAuthModal = closeModal;
    setAuthToken = setToken;

    if (isItEditorPage || isItAnniversaryLandingPage) {
        socialLoginTab = window.open(redirectUrl);
        reloadPage = isItAnniversaryLandingPage;
        tokenObserver();
        checkingCloseOrRejectionActions();
    }
    else {
        window.location = redirectUrl+'&state='+btoa(window.location.pathname+window.location.search);
    }
}

const tokenObserver = () => {
    showSpinner(true);
    window.onstorage = () => {
        if (!!window.localStorage.access_token) {
            hideSpinner();
            typeof closeAuthModal === 'function' && closeAuthModal();
            let accessToken = loadState(TOKEN);
            accessToken && setAuthToken(accessToken);
            reloadPage && location.reload();
        }
    }
}

const checkingCloseOrRejectionActions = () => {
    const intervalObj = setInterval(() => {
        if (socialLoginTab.closed) {
            hideSpinner();
            clearInterval(intervalObj);
        }
        try {
            let socialLoginTabDocument = socialLoginTab.document;
            let notAuthorized = socialLoginTabDocument.readyState == 'complete'
                && !!!socialLoginTab.localStorage.access_token
                && socialLoginTabDocument.location.href.includes('dashboard/personal');

            if (notAuthorized) {
                hideSpinner();
                clearInterval(intervalObj);
            }
        }
        catch (err) { }
    }, 1000);
}

const hideSpinner = () => {
    socialLoginTab.close();
    showSpinner(false);
}



// WEBPACK FOOTER //
// ./src/Account/SocialLoginHelper.js